import { useEffect, useState } from 'react';
import './App.css';
import Main from './screens/main';
import { initializeTheme } from './helper/useThemePreference';

// Runs once, before the first render, so the page never flashes the wrong theme.
initializeTheme();

const ANALYTICS_STORAGE_KEY = 'combos_analytics_consent';

const clearAnalyticsCookies = () => {
  document.cookie.split(';').forEach((cookie) => {
    const [name] = cookie.trim().split('=');
    if (!name) return;
    if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('AMP_TOKEN')) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
};

const disableGoogleAnalytics = () => {
  document.querySelectorAll('script[data-analytics-script="true"]').forEach((script) => script.remove());
  document.querySelectorAll('script[data-analytics-config="true"]').forEach((script) => script.remove());

  if (typeof window !== 'undefined') {
    window.dataLayer = [];
    window.gtag = undefined;
  }

  clearAnalyticsCookies();
};

const enableGoogleAnalytics = () => {
  if (document.querySelector('script[data-analytics-script="true"]')) {
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-0ZJN8Z7TP2';
  script.async = true;
  script.setAttribute('data-analytics-script', 'true');
  document.head.appendChild(script);

  const configScript = document.createElement('script');
  configScript.textContent = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'G-0ZJN8Z7TP2');
  `;
  configScript.setAttribute('data-analytics-config', 'true');
  document.head.appendChild(configScript);
};

function App() {
  const [analyticsConsent, setAnalyticsConsent] = useState(() => {
    if (typeof window === 'undefined') return false;
    const savedValue = window.localStorage.getItem(ANALYTICS_STORAGE_KEY);
    return savedValue === 'true';
  });
  const [showConsentBanner, setShowConsentBanner] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.localStorage.getItem(ANALYTICS_STORAGE_KEY) === null;
  });

  useEffect(() => {
    if (analyticsConsent) {
      enableGoogleAnalytics();
      return;
    }

    disableGoogleAnalytics();
  }, [analyticsConsent]);

  useEffect(() => {
    if (!analyticsConsent && !showConsentBanner) {
      disableGoogleAnalytics();
    }
  }, [analyticsConsent, showConsentBanner]);

  const handleConsent = (accepted) => {
    const nextValue = Boolean(accepted);
    setAnalyticsConsent(nextValue);
    setShowConsentBanner(false);
    window.localStorage.setItem(ANALYTICS_STORAGE_KEY, String(nextValue));
  };

  const handleOpenCookiePreferences = () => setShowConsentBanner(true);

  return (
    <div className="App">
      {showConsentBanner && (
        <div className="analytics-consent-banner" role="dialog" aria-live="polite">
          <div className="analytics-consent-text">
            We use Google Analytics to improve the game.
            <a href="/privacypolicy">Privacy Policy</a>
          </div>
          <div className="analytics-consent-actions">
            <button type="button" className="analytics-consent-button analytics-consent-secondary" onClick={() => handleConsent(false)}>
              Opt out
            </button>
            <button type="button" className="analytics-consent-button analytics-consent-primary" onClick={() => handleConsent(true)}>
              Accept
            </button>
          </div>
        </div>
      )}

      <header className="App-header">
        <Main analyticsConsent={analyticsConsent} onOpenCookiePreferences={handleOpenCookiePreferences} />
      </header>
    </div>
  );
}

export default App;
